import PropTypes from 'prop-types';

const languagePropType = PropTypes.shape({
    language: PropTypes.string,
    isReliable: PropTypes.bool,
});

export const ReviewItemPropTypeJSON = {
    username: PropTypes.string,
    work_sample_small: PropTypes.string,
    work_sample: PropTypes.string,
    user_image_url: PropTypes.string,
    value: PropTypes.number,
    comment: PropTypes.string,
    created_at: PropTypes.string,
    studioName: PropTypes.string,
    studioSlug: PropTypes.string,
    language: languagePropType,
    seller_response: PropTypes.shape({
        id: PropTypes.string,
        value: PropTypes.number,
        comment: PropTypes.string,
        created_at: PropTypes.string,
        language: languagePropType,
    }),
    reviews_count_as_buyer: PropTypes.number,
};
